import { useLocale } from '@gov-nx/core/service';
import {
	DataBoxFolderType,
	useDataBoxSearchFormContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { FormSearch } from '@gov-nx/ui/web';

const getLabel = (folderType: DataBoxFolderType) => {
	switch (folderType) {
		case DataBoxFolderType.Received:
			return 'slozky.v-dorucenych';
		case DataBoxFolderType.Sent:
			return 'slozky.v-odeslanych';
		case DataBoxFolderType.Archived:
			return 'slozky.v-archivu';
		case DataBoxFolderType.Trash:
		default:
			return 'slozky.v-kosi';
	}
};

interface DataBoxSearchProps {
	folderType: DataBoxFolderType;
}

export const DataBoxSearch = ({ folderType }: DataBoxSearchProps) => {
	const { t } = useLocale(PageCode['datove-schranky']);

	const label = t(getLabel(folderType));

	const { form, onSubmit } = useDataBoxSearchFormContext();

	return (
		<form
			onSubmit={form.handleSubmit(onSubmit)}
			className="w-full">
			<div className="relative">
				<FormSearch
					input={{
						field: {
							name: 'query',
							placeholder: label,
						},
						label: {
							children: label,
						},
					}}
					button={{
						'aria-label': t('vyhledavani.hledat'),
					}}
				/>
			</div>
		</form>
	);
};
